import { render, staticRenderFns } from "./setOrderStatus.vue?vue&type=template&id=693cadb2"
import script from "./setOrderStatus.vue?vue&type=script&lang=ts"
export * from "./setOrderStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports